create: Create Proposal
published: This proposal has been published.
publishing: Publishing Proposal...
view: View Proposal
wizard:
  title: Create a New Proposal
  successNotification: Proposal created
  steps:
    customerName:
      title: Who is the proposal for?
      description: |
        Enter the name of the principal customer or company. This is editable
        until the proposal is published.
    guests:
      title: How many guests?
      yachtLimitation: The guest & cabin options below are limited to those available on {{ yachtName }}.
      description:
        Select the number of guests, and optionally the number of cabins required.
    destination:
      title: Where is the charter destination?
      description: |
        This is required to provide more detailed yacht rate information where
        available, and sample itineraries.
      yachtLimitation: The destination options below are limited to where {{ yachtName }} is cruising.
      label: Destination
    currency:
      title: What currency should be used?
      explanation: "{{ currency }} has been selected based on the proposal's destination; changing this will add currency conversion."
    dates:
      title: When is the charter happening?
      description: |
        This is required to display seasonal or specific dates and more detailed
        yacht rate information where available.
      yachtLimitation: The date & season options below are limited to when {{ yachtName }} is cruising in {{ destination }}.
      availabilityTooltip:
        booked: '{{ yachtName }} is already booked on this date.'
        noRate: '{{ yachtName }} does not charter in {{ destination }} on this date.'
      availabilityAlert:
        booked: '{{ yachtName }} is already booked on those dates.'
        noRate: '{{ yachtName }} does not charter in {{ destination }} on those dates.'
sendViaEmail:
  title: Send via Email
  success: Email sent.
list:
  title: Charter Proposals
  sectionTitle:
    DRAFT: Drafts
    PUBLISHED: Published
    EXPIRED: Expired
details:
  section:
    basicDetails:
      title: Proposal Details
      update: Update Proposal Details
    itinerary:
      title: Itinerary
      update: Update Itinerary
      empty:
        alert: No sample itinerary has been selected.
        label: Add a Sample Itinerary
    yachtSelection:
      title: Yacht Selection
      empty:
        alert: No yachts have been added to this proposal.
        label: Search for Yachts
currency:
  description: Choose which currency you would like to be displayed in this proposal.
whiteLabel:
  label: Company Branding
  'true': Hide Branding
  'false': Display Branding
  description: Choose if you would like to your brokerage name and other contact details to be displayed in this proposal.
dates:
  mode:
    none: No Dates
    season: Season
    dates: Specific Dates
itinerary:
  title: Select Sample Itinerary
  none: No Itinerary
  reverseStops: Reverse Itinerary Stops
yachtSelection:
  add: Add Yachts to Proposal
  none: No Yachts Selected
yacht:
  price: Price
  noPrice: No price has been set for this yacht
  charterFee: Charter Fee
  apaPercent: APA %
  apa: APA
  taxPercent: Tax %
  tax: TAX
  deliveryFee: Delivery Fee
  note: Custom Note
  addNote: Add a Custom Note
  total: Total
publish:
  title: Publish Proposal
  confirmation: Are you ready to publish this proposal?
  description: Once a proposal is published, you will no longer be able to edit it.
  success: Proposal published!
retract:
  title: Retract Proposal
  description: Once a proposal is retracted, it will no longer be available to view.
  label: Retract
  notification: Proposal retracted
expired: This proposal has expired.
retracted: You have retracted this proposal.
status:
  DRAFT: Draft
  PUBLISHED: Published
  RETRACTED: Retracted
  EXPIRED: Expired
  LAPSED: Lapsed
warnings:
  header:
    yachts: 'The following yachts do not operate in the selected destination ({{ destinationName }}):'
    itinerary: The itinerary you have selected does not cover the selected destination ({{ destinationName }}).
  item:
    yacht: This yacht does not operate in the selected destination ({{ destinationName }}).
    itinerary: This itinerary does not cover the selected destination ({{ destinationName }}).
